import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    Table,
    Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
//import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import { isEmpty } from "lodash"
import * as clientAction from "../../../store/cGVuZGluZ1By/actions"
import ButtonSpinner from "components/ButtonSpinner"

import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import api from "helpers/Api"
import ReactDOM from 'react-dom'
import TabComponent from "./TabComponent"

const PendingProductWiseClientCount = (props) => {
    const { searchBtnStyle, dispatch } = props

    const title = "Pending Product Wise Client Count"
    const CRMEmpId = localStorage.getItem("empId")
    //Fetching API
    useEffect(() => {
        dispatch(clientAction.loadPendingProductWiseClientCount({
            CRMEmpId: [CRMEmpId]
        }))

    }, [])

    const update = useSelector(
        (specificstate) => specificstate.pendingProductWIseClientCount
    )
    //product_data
    const { product_data = [] } = update

    //Handle Change
    const [productStatusData, setProductStatusData] = useState({
        eventFromDate: "",
        eventToDate: "",
    })

    const handleChange = (e) => {
        setProductStatusData({
            ...productStatusData,
            [e.target.name]: e.target.value,
        })
    }

    //date format
    const sessionUpdate = useSelector((specificstate) => specificstate.session)

    const { user = [] } = sessionUpdate
    const authUser = localStorage.getItem("authUser")

    const responseLogin = JSON.parse(authUser)
    //Date format
    const dateSetting =
        !isEmpty(responseLogin) &&
            responseLogin.setting &&
            responseLogin.setting.dateFormate
            ? responseLogin.setting.dateFormate.toUpperCase()
            : !isEmpty(user) && user.setting && user.setting.dateFormate
                ? user.setting.dateFormate.toUpperCase()
                : []

    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""


    const [downloadLoading, setDownloadLoading] = useState(false)
    //Search value

    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [btnLoader, setBtnLoader] = useState(false)



    const handleFilter = (e) => {
        e.preventDefault()

        // var searchEmployee = !isEmpty(products) && products ? products : ""
        var searchFromDate =
            productStatusData && productStatusData.eventFromDate
                ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            productStatusData && productStatusData.eventToDate
                ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}
        searchvalue.CRMEmpId = [CRMEmpId]

        if (searchFromDate) {
            searchvalue.eventFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.eventToDate = searchToDate
        }

        dispatch(clientAction.loadPendingProductWiseClientCount(searchvalue))
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 3000)
    }

    //reset

    const resetForm = () => {

        setSearchInput("")
        //    setEmployee([])
        setProductStatusData({
            ...productStatusData,
            eventFromDate: "",
            eventToDate: "",
        })
        dispatch(clientAction.loadPendingProductWiseClientCount({
            CRMEmpId: [CRMEmpId]
        }))
    }

    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        dispatch(clientAction.loadPendingProductWiseClientCount({
            CRMEmpId: [CRMEmpId]
        }))
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }
   //download csv
    const exportToCsv = () => {
        const searchFromDate = productStatusData?.eventFromDate
            ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
            : ""
    
        const searchToDate = productStatusData?.eventToDate
            ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
            : ""
    
        const searchvalue = { CRMEmpId: [CRMEmpId] }
    
        if (searchFromDate) searchvalue.eventFromDate = searchFromDate
        if (searchToDate) searchvalue.eventToDate = searchToDate
    
        setDownloadLoading(true)
    
        api.post(`/get_CrmWorker_processStatus`, searchvalue)
            .then((response) => {
                const data = response.data.data
    
                console.log(data, "API Response Data")
    
                if (!data || isEmpty(data)) {
                    console.warn("No data received from API")
                    setDownloadLoading(false)
                    return
                }
    
                // List of numeric fields to sum (excluding unwanted properties)
                const numericFields = [
                    "pendingLeads",
                    "pendingUniqueClients",
                    "deliverable_one",
                    "deliverable_second",
                    "deliverable_three",
                    "deliverable_greaterthen_three",
                    "eventClient_one",
                    "eventClient_two",
                    "eventClient_greaterthen_two",
                    "completedClients"
                ]
    
                const totalSum = numericFields.reduce((acc, key) => acc + (data[key] || 0), 0)
    
                const csvData = [
                    ["CRM Report", "Count", "Total"].join(","), // CSV Header
                    ["Pending Leads", data.pendingLeads || 0, data.pendingLeads || 0].join(","),
                    ["Pending Unique Clients", data.pendingUniqueClients || 0, data.pendingUniqueClients || 0].join(","),
                    ["Deliverable One", data.deliverable_one || 0, data.deliverable_one || 0].join(","),
                    ["Deliverable Second", data.deliverable_second || 0, data.deliverable_second || 0].join(","),
                    ["Deliverable Three", data.deliverable_three || 0, data.deliverable_three || 0].join(","),
                    ["Deliverable Greater Than Three", data.deliverable_greaterthen_three || 0, data.deliverable_greaterthen_three || 0].join(","),
                    ["Events Clients One", data.eventClient_one || 0, data.eventClient_one || 0].join(","),
                    ["Events Clients Two", data.eventClient_two || 0, data.eventClient_two || 0].join(","),
                    ["Events Clients Greater Than Two", data.eventClient_greaterthen_two || 0, data.eventClient_greaterthen_two || 0].join(","),
                    ["Completed Clients", data.completedClients || 0, data.completedClients || 0].join(","),
                    ["Total", totalSum, totalSum].join(",")
                ].join("\n")
    
                downloadFile({
                    data: csvData,
                    fileName: "PendingProductWiseClientCount.csv",
                    fileType: "text/csv"
                })
    
                setDownloadLoading(false)
            })
            .catch((error) => {
                console.error("Error exporting CSV:", error)
                setDownloadLoading(false)
            })
    }
    
    const handleClickTab = (tableData) => {

        const statusName = tableData.status
        const mode = tableData.mode
        const statusDetails = {
            CRMEmpId: CRMEmpId,
            menuMode: tableData.mode,
            // isPending:false
        }

        if (productStatusData.eventFromDate) {
            statusDetails.eventFromDate = productStatusData.eventFromDate
        }
        if (productStatusData.eventToDate) {
            statusDetails.eventToDate = productStatusData.eventToDate
        }



        api
            .post(`/get_CrmWorker_detailed_processStatus_new`, statusDetails)
            .then((response) => {
                const statusData = !isEmpty(response.data.data) ? response.data.data : []
                setTimeout(() => {
                    // Use the current value of statusData, which should be updated due to the useEffect

                    const newTab = window.open("", "_blank", "width=600,height=400")
                    if (newTab) {
                        const container = newTab.document.createElement("div")
                        const fallbackDateFormat = "dd/mm/yyyy"
                        newTab.document.body.appendChild(container)
                        ReactDOM.render(
                            <TabComponent
                                data={statusData} // Use statusData directly here
                                dispatch={dispatch}
                                statusPayload={statusDetails}
                                name={statusName}
                                mode={mode}
                                dateFormat={dateFormat || fallbackDateFormat}
                            />,
                            container
                        )
                        newTab.document.title = "CRM-WISE-PENDING-CLIENT-COUNT"
                    }
                }, 1500)
            })
            .catch((error) => {
                Promise.reject(error)
                const newTab = window.open("", "_blank", "width=600,height=400")
                if (newTab) {
                    const container = newTab.document.createElement("div")
                    newTab.document.body.appendChild(container)
                    ReactDOM.render(
                        <TabComponent
                            data={[]} // Use statusData directly here
                            dispatch={dispatch}
                            statusPayload={statusDetails}
                            name={statusName}
                            dateFormat={dateFormat}
                            mode={mode}
                        />,
                        container
                    )
                    newTab.document.title = "CRM-WISE-PENDING-CLIENT-COUNT"
                }
            })
    }



    const countValues = !isEmpty(product_data) ? product_data : {}

    const totalCounts = !isEmpty(countValues)
        ? (Number(countValues.pendingLeads || 0) +
            Number(countValues.pendingUniqueClients || 0) +
            Number(countValues.deliverable_one || 0) +
            Number(countValues.deliverable_second || 0) +
            Number(countValues.deliverable_three || 0) +
            Number(countValues.deliverable_greaterthen_three || 0) +
            Number(countValues.eventClient_one
                || 0) +
            Number(countValues.eventClient_two || 0) +
            Number(countValues.eventClient_greaterthen_two || 0) +
            Number(countValues.completedClients || 0))
        : 0
    console.log(product_data, "product_data")
    console.log(countValues, "countvalues")
    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <form>
                                    <Row>


                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label className={"form-label"} htmlFor={"Event Date"}>
                                                    {"Event From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventFromDate"
                                                value={productStatusData.eventFromDate}
                                                max={productStatusData.eventToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Event To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventToDate"
                                                value={productStatusData.eventToDate}
                                                min={productStatusData.eventFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                                            <div
                                                className="filter-buttons"
                                                style={{ float: "right" }}
                                            >
                                                <Button
                                                    type="button"
                                                    className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                                                    onClick={() => {
                                                        resetForm()
                                                    }}
                                                >
                                                    <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={(e) => handleFilter(e)}
                                                    className="btn btn-success btn-label simple-form-applyfilter-btn"
                                                >
                                                    <i className="bx bx-filter-alt label-icon"></i>
                                                    {btnLoader && btnLoader ? (
                                                        <ButtonSpinner />
                                                    ) : (
                                                        "Apply Filter"
                                                    )}{" "}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md="12" lg="12" xl="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <form onSubmit={handleClick} className="d-flex flex-row">
                                            <div style={searchBtnStyle || null}>
                                                <Input
                                                    type="text"
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search"
                                                    style={{ position: "relative" }}
                                                />
                                                <i
                                                    className="bx bx-search-alt"
                                                    style={{
                                                        position: "absolute",
                                                        top: "54px",
                                                        left: "41px",
                                                        fontSize: "13px",
                                                    }}
                                                />
                                            </div>

                                            <button
                                                className="btn btn-success mx-2"
                                                type="submit"
                                                style={{
                                                    background: searchFilter ? "#2ca67a" : "",
                                                    color: searchFilter ? "#ffffff" : "",
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <Row>
                                    <Col md="4" lg="4" sm="12"></Col>
                                    <Col
                                        md="8"
                                        lg="8"
                                        sm="12"
                                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                                    >
                                        <div
                                            style={{
                                                float: "right",
                                            }}
                                        >
                                            <Button
                                                className="btn btn-primary"
                                                onClick={exportToCsv}
                                                id="download"
                                                style={{
                                                    backgroundColor: "#e40d8c",
                                                    color: "white",
                                                    border: "none",
                                                }}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>

                                <Col md="12" lg="12" xl="12" className="mt-3">

                                    <Table responsive bordered>
                                        <thead>
                                            <tr>
                                                <th style={{
                                                    minWidth: "200px",
                                                }}>CRM Report</th>

                                                <th style={{
                                                    minWidth: "160px"
                                                }}>Count</th>
                                                {/* <th style={{
                                                    minWidth: "160px"
                                                }}>Average Age In Days</th> */}
                                                <th style={{
                                                    minWidth: "160px"
                                                }}>Total</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th>Pending Leads</th>
                                                <td style={{
                                                    fontWeight: 'bold',
                                                    color: "#e40d8c",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                }}
                                                    onClick={() => handleClickTab({
                                                        mode: 1,
                                                        status: 'Pending Leads'
                                                    })}>{!isEmpty(countValues) ? countValues.pendingLeads : 0}</td>
                                                <td >{!isEmpty(countValues) ? countValues.pendingLeads : 0}</td>
                                                {/* // <td>{!isEmpty(countValues) ? countValues.pendingLeadsAverageAgeInDays : 0}</td> */}
                                                {/* <td>{!isEmpty(countValues.pendingLeadsAverageAgeInDays) ? parseInt(countValues.pendingLeads + countValues.pendingLeadsAverageAgeInDays) : 0}</td> */}
                                            </tr>
                                            <tr>
                                                <th>Pending Unique Clients</th>
                                                <td style={{
                                                    fontWeight: 'bold',
                                                    color: "#e40d8c",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                }}
                                                    onClick={() => handleClickTab({
                                                        mode: 2,
                                                        status: "Pending Unique Clients"
                                                    })}>{!isEmpty(countValues) ? countValues.pendingUniqueClients : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.pendingUniqueClients : 0}</td>
                                                {/* <td>{!isEmpty(countValues.pendingUniqueClientsAverageAgeInDays) ? countValues.pendingUniqueClientsAverageAgeInDays : 0}</td>
                                                <td>{!isEmpty(countValues.pendingUniqueClientsAverageAgeInDays) ? parseInt(countValues.pendingUniqueClients + countValues.pendingUniqueClientsAverageAgeInDays) : 0}</td> */}
                                            </tr>
                                            <tr>
                                                <th>Deliverable One</th>
                                                <td style={{
                                                    fontWeight: 'bold',
                                                    color: "#e40d8c",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                }}
                                                    onClick={() => handleClickTab({
                                                        mode: 4,
                                                        status: "Deliverable One"
                                                    })}>{!isEmpty(countValues) ? countValues.deliverable_one : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.deliverable_one : 0}</td>
                                                {/* <td>{!isEmpty(countValues.deliverable_oneAverageAgeInDays) ? countValues.deliverable_oneAverageAgeInDays : 0}</td>
                                                <td>{!isEmpty(countValues.deliverable_oneAverageAgeInDays) ? countValues.deliverable_one + countValues.deliverable_oneAverageAgeInDays : 0}</td> */}
                                            </tr>
                                            <tr>
                                                <th>Deliverable Second</th>
                                                <td style={{
                                                    fontWeight: 'bold',
                                                    color: "#e40d8c",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                }}
                                                    onClick={() => handleClickTab({
                                                        mode: 5,
                                                        status: "Deliverable Second"
                                                    })}>{!isEmpty(countValues) ? countValues.deliverable_second : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.deliverable_second : 0}</td>
                                                {/* <td>{!isEmpty(countValues.deliverable_secondAverageAgeInDays) ? countValues.deliverable_secondAverageAgeInDays : 0}</td>
                                                <td>{!isEmpty(countValues.deliverable_secondAverageAgeInDays) ? countValues.deliverable_second + countValues.deliverable_secondAverageAgeInDays : 0}</td> */}
                                            </tr>
                                            <tr>
                                                <th>Deliverable Three</th>
                                                <td style={{
                                                    fontWeight: 'bold',
                                                    color: "#e40d8c",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                }}
                                                    onClick={() => handleClickTab({
                                                        mode: 6,
                                                        status: "Deliverable Three"
                                                    })}>{!isEmpty(countValues) ? countValues.deliverable_three : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.deliverable_three : 0}</td>
                                                {/* <td>{!isEmpty(countValues.deliverable_threeAverageAgeInDays) ? countValues.deliverable_threeAverageAgeInDays : 0}</td>
                                                <td>{!isEmpty(countValues.deliverable_threeAverageAgeInDays) ? countValues.deliverable_three + countValues.deliverable_threeAverageAgeInDays : 0}</td> */}
                                            </tr>
                                            <tr>
                                                <th>Deliverable Greater Than Three</th>
                                                <td style={{
                                                    fontWeight: 'bold',
                                                    color: "#e40d8c",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                }}
                                                    onClick={() => handleClickTab({
                                                        mode: 7,
                                                        status: 'Deliverable Greater Than Three'
                                                    })}>{!isEmpty(countValues) ? countValues.deliverable_greaterthen_three : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.deliverable_greaterthen_three : 0}</td>

                                            </tr>
                                            <tr>
                                                <th>Events Clients One</th>
                                                <td>{!isEmpty(countValues) ? countValues.eventClient_one
                                                    : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.eventClient_one
                                                    : 0}</td>

                                            </tr>
                                            <tr>
                                                <th>Events Clients Two</th>
                                                <td >{!isEmpty(countValues) ? countValues.eventClient_two : 0}</td>
                                                <td>{!isEmpty(countValues) && countValues.eventClient_two ? countValues.eventClient_two : 0}</td>

                                            </tr>
                                            <tr>
                                                <th>Events Clients Greaterthan Two</th>
                                                <td>{!isEmpty(countValues) ? countValues.eventClient_greaterthen_two : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.eventClient_greaterthen_two : 0}</td>
                                            </tr>
                                            <tr>
                                                <th>Completed Clients</th>
                                                <td style={{
                                                    fontWeight: 'bold',
                                                    color: "#e40d8c",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                }}
                                                    onClick={() => handleClickTab({
                                                        mode: 8,
                                                        status: 'Complients Clients'
                                                    })}>{!isEmpty(countValues) ? countValues.completedClients : 0}</td>
                                                <td>{!isEmpty(countValues) ? countValues.completedClients : 0}</td>

                                            </tr>
                                            <tr>
                                                <th>Total</th>
                                                <th>{totalCounts}</th>
                                                <th>{totalCounts}</th>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <div className="font-size-14 mt-2">
                                        <p>Showing Rows 1 to 9 of 9</p>
                                    </div>
                                </Col>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {downloadLoading ? (
                <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}
        </div>
    )
}
PendingProductWiseClientCount.propTypes = {
    dispatch: PropTypes.func,
    searchBtnStyle: PropTypes.any,
    dateFormat: PropTypes.string
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,PendingProductWiseClientCount
})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PendingProductWiseClientCount)
)
